import { combineEpics } from "redux-observable";
import passwordTips$ from "./passwordTips/passwordTips.epic";
import verifyPassword$ from "./verifyPassword/verifyPassword.epic";
export default combineEpics(passwordTips$, verifyPassword$);